export default __webpack_public_path__ + "static/placeholder-pdf-5ac85b278dc559402ece53b3ad81b0e4.pdf";